function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { combine, isEmptyObject, display, createEventRateLimiter, DISCARDED, buildTags } from '@datadog/browser-core';
import { RumEventType } from '../rawRumEvent.types';
import { limitModification } from './limitModification';
var VIEW_MODIFIABLE_FIELD_PATHS = {
  'view.name': 'string',
  'view.url': 'string',
  'view.referrer': 'string'
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
  context: 'object'
};
var ROOT_MODIFIABLE_FIELD_PATHS = {
  service: 'string',
  version: 'string'
};
var modifiableFieldPathsByEvent;
export function startRumAssembly(configuration, lifeCycle, hooks, reportError) {
  var _modifiableFieldPaths, _eventRateLimiters;

  modifiableFieldPathsByEvent = (_modifiableFieldPaths = {}, _defineProperty(_modifiableFieldPaths, RumEventType.VIEW, _objectSpread(_objectSpread(_objectSpread({
    'view.performance.lcp.resource_url': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), _defineProperty(_modifiableFieldPaths, RumEventType.ERROR, _objectSpread(_objectSpread(_objectSpread({
    'error.message': 'string',
    'error.stack': 'string',
    'error.resource.url': 'string',
    'error.fingerprint': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), _defineProperty(_modifiableFieldPaths, RumEventType.RESOURCE, _objectSpread(_objectSpread(_objectSpread({
    'resource.url': 'string',
    'resource.graphql.variables': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), _defineProperty(_modifiableFieldPaths, RumEventType.ACTION, _objectSpread(_objectSpread(_objectSpread({
    'action.target.name': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), _defineProperty(_modifiableFieldPaths, RumEventType.LONG_TASK, _objectSpread(_objectSpread(_objectSpread({
    'long_task.scripts[].source_url': 'string',
    'long_task.scripts[].invoker': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), _defineProperty(_modifiableFieldPaths, RumEventType.VITAL, _objectSpread(_objectSpread(_objectSpread({}, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), _modifiableFieldPaths);
  var eventRateLimiters = (_eventRateLimiters = {}, _defineProperty(_eventRateLimiters, RumEventType.ERROR, createEventRateLimiter(RumEventType.ERROR, configuration.eventRateLimiterThreshold, reportError)), _defineProperty(_eventRateLimiters, RumEventType.ACTION, createEventRateLimiter(RumEventType.ACTION, configuration.eventRateLimiterThreshold, reportError)), _defineProperty(_eventRateLimiters, RumEventType.VITAL, createEventRateLimiter(RumEventType.VITAL, configuration.eventRateLimiterThreshold, reportError)), _eventRateLimiters);
  lifeCycle.subscribe(12
  /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */
  , function (_ref) {
    var startTime = _ref.startTime,
        duration = _ref.duration,
        rawRumEvent = _ref.rawRumEvent,
        domainContext = _ref.domainContext;
    var defaultRumEventAttributes = hooks.triggerHook(0
    /* HookNames.Assemble */
    , {
      eventType: rawRumEvent.type,
      startTime: startTime,
      duration: duration
    });

    if (defaultRumEventAttributes === DISCARDED) {
      return;
    }

    var serverRumEvent = combine(defaultRumEventAttributes, rawRumEvent, {
      ddtags: buildTags(configuration).join(',')
    });

    if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
      if (isEmptyObject(serverRumEvent.context)) {
        delete serverRumEvent.context;
      }

      lifeCycle.notify(13
      /* LifeCycleEventType.RUM_EVENT_COLLECTED */
      , serverRumEvent);
    }
  });
}

function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
  var _a;

  if (beforeSend) {
    var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
      return beforeSend(event, domainContext);
    });

    if (result === false && event.type !== RumEventType.VIEW) {
      return false;
    }

    if (result === false) {
      display.warn("Can't dismiss view events using beforeSend!");
    }
  }

  var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
  return !rateLimitReached;
}